import {
  createFileRoute,
  Link,
  useCanGoBack,
  useRouter,
} from '@tanstack/react-router';
import { CircleArrowLeft } from 'lucide-react';

import { ClassAnalyticsDashboard } from '~pages/classes/class-analytics-dashboard';

import { Button } from '~shared/shadcn/ui/button';

export const Route = createFileRoute('/_auth/_layout/class-analytics/$classId')(
  {
    component: RouteComponent,
  },
);

function RouteComponent() {
  const { classId } = Route.useParams();

  const router = useRouter();
  const canGoBack = useCanGoBack();

  return (
    <div>
      <div className='mb-8 flex items-center gap-2'>
        {canGoBack ? (
          <>
            <Button
              variant={'ghost'}
              className='flex items-center p-2 [&_svg]:size-6'
              disabled={!canGoBack}
              onClick={() => {
                router.history.back();
              }}
            >
              <CircleArrowLeft className='size-6' />
            </Button>
            <h2 className='text-2xl font-semibold'>
              Class Attendance Analytics
            </h2>
          </>
        ) : (
          <Link to='/dashboard' className='flex items-center gap-2'>
            <CircleArrowLeft className='size-6' />
            <h2 className='text-2xl font-semibold'>
              Class Attendance Analytics
            </h2>
          </Link>
        )}
      </div>
      <ClassAnalyticsDashboard classId={classId} />
    </div>
  );
}
